import React, { Fragment } from 'react';
import FormField from './FormField';
import './InfoSection.scss';
import { formatEnumLabel } from '../common/helper';
import { DropdownOption } from '@salvapp/ui-components/build/dropdown/dropdown.types';
import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(AdvancedFormat);

const formattedValue = (value?: string | number | Date, type?: string): string => {
  if (!value) {
    return '-';
  } else if (type === undefined) {
    return value.toString();
  } else if (type === 'datetime') {
    return dayjs(value).format('dddd, MMMM Do YYYY HH:mm');
  }
  return formatEnumLabel(value.toString());
};

export const InfoSection = ({
  id,
  editing,
  name,
  type,
  label,
  text,
  minValue,
  placeholder,
  options,
  value,
  disabled,
}: {
  id?: string;
  editing: boolean;
  name: string;
  label: string;
  value?: string | number | Date;
  type?: string;
  text?: string;
  minValue?: number;
  placeholder?: string;
  options?: DropdownOption[];
  disabled?: boolean;
}) => {
  return (
    <Fragment>
      {editing ? (
        <FormField
          id={id}
          name={name}
          type={type}
          label={label}
          text={text}
          minValue={minValue}
          placeholder={placeholder}
          options={options}
          disabled={disabled}
        />
      ) : (
        <>
          <label className={'form-label'}>{label}</label>
          {text && <small className={'form-text text-muted'}>{text}</small>}
          <div className={'section-value'}>{formattedValue(value, type)}</div>
        </>
      )}
    </Fragment>
  );
};

export default InfoSection;
